import http from './http'

class Invoice {
  available (page) {
    const url = page !== undefined ? `/invoices/available_invoices?page=${page}` : '/invoices/available_invoices'
    return http.get(url)
  }

  filterAvailable (filter) {
    return http.get(`/invoices/available_invoices?filter=${filter}`)
  }

  totalAvailable () {
    return http.get('/invoices/total_available_invoices')
  }

  selectedAvailable (payload) {
    return http.post('/invoices/selected_available_invoices', payload)
  }

  simulate (payload) {
    return http.post('/invoices/simulate', payload)
  }

  taxCommission () {
    return http.get('/invoices/tax_commission')
  }

  exampleInvoiceRequest (payload) {
    return http.post('/invoice_request/example', payload)
  }

  saveInvoiceRequest (payload) {
    return http.post('/invoice_request', payload)
  }

  byAssignor (payload) {
    return http.get(`/invoices_by_assignor/${payload}`)
  }
}

export default new Invoice()



// WEBPACK FOOTER //
// ./src/services/invoice.js